// src/api/cms.js
import request from '@/utils/request';

// --- About Us ---
export const getAboutus = () => {
  return request({ url: '/aboutus/all', method: 'get' });
};
export const updateAboutUs = (data) => {
  return request({ url: '/aboutus/add', method: 'post', data });
};

// --- Environment ---
export const getEnvironment = () => {
  return request({ url: '/environment/all', method: 'get' });
};
export const updateEnvironment = (data) => {
  return request({ url: '/environment/add', method: 'post', data });
};

// --- Quality ---
export const getQuality = () => {
  return request({ url: '/quality/all', method: 'get' });
};
export const updateQuality = (data) => {
  return request({ url: '/quality/add', method: 'post', data });
};

// --- Join Us ---
export const getJoinus = () => {
  return request({ url: '/joinus/all', method: 'get' });
};
export const updateJoinus = (data) => {
  return request({ url: '/joinus/add', method: 'post', data });
};

// --- Aftersale ---
export const getAftersale = () => {
  return request({ url: '/aftersale/all', method: 'get' });
};
export const updateAftersale = (data) => {
  return request({ url: '/aftersale/add', method: 'post', data });
};

// --- Contact ---
export const getContact = () => {
  return request({ url: '/contact/all', method: 'get' });
};
export const updateContact = (data) => {
  return request({ url: '/contact/add', method: 'post', data });
};